import styles from "./ButtonCombo.module.css";

import type { ReactNode } from "react";
import cn from "classnames";

interface Props {
  // Should contain two or more Buttons (see components/Button/).
  children: ReactNode;
  className?: string;
}

export function ButtonCombo(props: Props) {
  return (
    <div className={cn(styles.buttonCombo, props.className)}>
      {props.children}
    </div>
  );
}
